import * as Backbone from "backbone";
import {InstallCollection} from "../../collections/Installs";
import {PermissionCollection} from "../../collections/Permissions";
import {OrganizationCollection} from "../../collections/Organizations";
import {DashboardChannelCollection} from "../../collections/DashboardChannels";
import {User} from "../../models/User";


export interface BaseSettingsViewOptions extends Backbone.ViewOptions<Backbone.Model> {
    installCollection: InstallCollection;
    permissionCollection: PermissionCollection;
    organizationCollection: OrganizationCollection;
    dashboardChannelCollection: DashboardChannelCollection;
    installId: number;
    moduleId: number
    orgId: number;
    currentUser: User;
}

export class BaseSettingsView extends Backbone.View<Backbone.Model> {

    options: BaseSettingsViewOptions;

    constructor(options: BaseSettingsViewOptions) {
        super(options)
    };

    initialize(options: BaseSettingsViewOptions) {
        super.initialize(options);
        this.options = options;
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/views/settings/_BaseSettingsView.ts